import { gql } from "apollo-angular";
import {
  baseGraphqlField,
  basePageableGraphqlField,
  baseResponseField,
} from "../../base/base.graphql";

export const userField = `
${baseGraphqlField}
  accountNonExpired
  accountNonLocked
  authenticationType
  authorities{
  authority
  }
  credentialsNonExpired
  designation{
  uid
  id
  name
  }
  email
  enabled
  firstName
  fullName
  institution{
  id
  uid
  name
  institutionRole
  forensicOrgan
  voteCode
  }
  lastName
  lockTime
  lockoutTime
  loginAttemptCount
  middleName
  phoneNumber
  phoneVerified
  roles{
  id
  uid
  name
  displayName
  }
  userType
  username

`;

// a user's account on the HAJIS server, read for the roles it holds
export const GET_USER_ACCOUNT_BY_UID = gql`
  query getUserAccountByUid($userUid: String) {
    getUserAccountByUid(userUid: $userUid) {
      ${baseResponseField}
      data {
        uid
        fullName
        roles {
          uid
          name
          displayName
        }
      }
    }
  }
`;

// replaces the roles a user holds on the HAJIS server
export const ASSIGN_ROLE_TO_USER = gql`
  mutation assignRoleToUserAccount($roleUidList: [String], $userUid: String) {
    assignRoleToUserAccount(roleUidList: $roleUidList, userUid: $userUid) {
      ${baseResponseField}
    }
  }
`;

export const MY_DETAILS = gql`
    query myDetails {
        myDetails {
            ${baseResponseField}
            data{
                ${userField}
                workingOfficeLevel
                workingOfficeLocation {
                  uid
                  areaName
                  locationLevel
                }
            }
        }
    }
`;

export const RESET_PASSWORD = gql`
  mutation resetUserPassword($userUid: UUID) {
    resetUserPassword(userUid: $userUid) {
      ${baseResponseField}
      data
    }
  }
`;

export const CHANGE_PASSWORD = gql`
  mutation changeMyPassword($updatePasswordDto: UpdatePasswordRequestInput) {
    changeMyPassword(updatePasswordDto: $updatePasswordDto) {
      ${baseResponseField}
      data
    }
  }
`;

export const genericPortalUserField = `
  ${baseGraphqlField}
  accountNonExpired
  accountNonLocked
  activatedAt
  authenticationType
  bulkDeactivate
  credentialsNonExpired
  deletedAt
  email
  emailVerified
  enabled
  firstLogin
  firstName
  fullName
  lastName
  lockTime
  lockoutTime
  loginAttemptCount
  middleName
  ngaoEnabled
  phoneNumber
  phoneVerified
  registeredToNgao
  updatedAt
  userType
  username
  workingOfficeLevel
  workingOfficeLocation {
    areaCode
    areaName
    id
    locationLevel
    napaId
    uid
  }
`;

/** Toggles the account: activates an inactive user, deactivates an active one. */
export const ACTIVATE_GENERIC_PORTAL_USER_ACCOUNT = gql`
  mutation activateGenericPortalUserAccount($userUid: String) {
    activateGenericPortalUserAccount(userUid: $userUid) {
      ${baseResponseField}
      data {
        ${genericPortalUserField}
      }
    }
  }
`;

export const GET_GENERIC_PORTAL_USER_ACCOUNTS = gql`
  query getGenericPortalUserAccounts($pageableParam: PageableParamInput) {
    getGenericPortalUserAccounts(pageableParam: $pageableParam) {
      ${baseResponseField}
      data {
        ${basePageableGraphqlField}
        content {
          ${genericPortalUserField}
        }
      }
    }
  }
`;

export const UPDATE_GENERIC_PORTAL_USER_WORKING_LEVEL = gql`
  query updateGenericPortalUserWorkingLevel(
    $workingOfficeDto: GenericUserWorkingLevelDtoInput
  ) {
    updateGenericPortalUserWorkingLevel(workingOfficeDto: $workingOfficeDto) {
      ${baseResponseField}
      data {
        ${genericPortalUserField}
      }
    }
  }
`;

export const SAVE_GENERIC_PORTAL_USER_ACCOUNT = gql`
  mutation saveGenericPortalUserAccount($genericPortalUserAccountDto: GenericPortalUserAccountDtoInput) {
    saveGenericPortalUserAccount( genericPortalUserAccountDto: $genericPortalUserAccountDto) {
      ${baseResponseField}
      data{
      ${genericPortalUserField}
      }
    }
  }
`;
